module.exports = __webpack_public_path__ + "img/fktyc.54dfb6be.png";